import React from 'react';
import createSVG from '../createSVG';

const ReferenzenIconBig = ({style}) => (
  <path style={style} fill="#6ED2A0" d="m504 512l-322 0c-5 0-8-3-8-8l0-248c0-4 3-8 8-8l322 0c5 0 8 4 8 8l0 248c0 5-3 8-8 8z m-315-15l308 0 0-233-308 0z m-32-109l-62 0c-5 0-8-4-8-8l0-248c0-4 3-8 8-8l322 0c5 0 8 4 8 8l0 99c0 4-3 8-8 8-4 0-7-4-7-8l0-91-308 0 0 232 55 0c4 0 7 4 7 8 0 4-3 8-7 8z m-87-124l-62 0c-5 0-8-4-8-8l0-248c0-5 3-8 8-8l322 0c5 0 8 3 8 8l0 99c0 4-3 8-8 8-4 0-7-4-7-8l0-92-308 0 0 233 55 0c4 0 7 4 7 8 0 4-3 8-7 8z"/>
);

export default createSVG(ReferenzenIconBig);
